import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en_US from './language/en_US.js'
import zh_TW from './language/zh_TW.js'
import zh_CH from './language/zh_CH.js'
import ko_KR from './language/ko_KR.js'
import vi_VN from './language/vi_VN.js'
import th_TH from './language/th_TH.js'
import ru_RU from './language/ru_RU.js'
import store from '@/utils/store/index.js'

Vue.use(VueI18n)

const i18n = new VueI18n({
	messages: {
		en_US,
		zh_TW,
		zh_CH,
		ko_KR,
		vi_VN,
		th_TH,
		ru_RU
	},
	fallbackLocale: 'en_US',
	locale: store.state.gameData.language
})

export default i18n